import script from "./TrialExpiringModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrialExpiringModal.vue?vue&type=script&setup=true&lang=ts"

import "./TrialExpiringModal.vue?vue&type=style&index=0&id=bfcbe402&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfcbe402"]])

export default __exports__